import request from '@/utils/requestWrapper'

// ==============================================
// 最终正确两套服务
// 登录：/api/auth/login        → 8082 统一认证
// 注册：/api/auth/register     → 8082 统一认证
// 其他：/api/user/xxx          → 8091 业务服务
// ==============================================

// 获取当前用户信息 → 数字名片后端
export const getCurrentUserInfo = () => {
  const { getUserId } = require('@/utils/auth')
  const userId = getUserId()
  if (!userId) {
    console.warn('用户未登录，无法获取用户信息')
    return Promise.reject(new Error('用户未登录'))
  }
  return request({
    url: '/api/user/info',
    method: 'GET',
    params: { userId: userId }
  })
}

// 手机号查询用户 → 数字名片后端
export const loginByPhone = (phone) => {
  if (!phone) {
    console.error('登录验证失败：手机号不能为空')
    return Promise.reject(new Error('手机号不能为空'))
  }
  return request({
    url: `/api/user/phone/${phone}`,
    method: 'GET'
  })
}

// 获取用户信息（手机号）→ 数字名片后端
export const getUserByPhone = (phone) => {
  if (!phone) {
    console.error('查询用户失败：手机号不能为空')
    return Promise.reject(new Error('手机号不能为空'))
  }
  return request({
    url: `/api/user/phone/${phone}`,
    method: 'GET'
  })
}

// 根据ID获取用户 → 数字名片后端
export const getUserById = (id) => {
  return request({
    url: `/api/user/id/${id}`,
    method: 'GET'
  })
}

// 更新用户 → 数字名片后端
export const updateUser = (user) => {
  console.log('🔍 [API DEBUG] updateUser 收到 user.username =', JSON.stringify(user?.username))
  console.log('🔍 [API DEBUG] updateUser 收到 user keys =', Object.keys(user || {}))
  // 构建只包含后端支持字段的用户信息对象，排除password和passwordHash
  // ✅ 只读/敏感唯一字段黑名单：禁止通过 updateUser 回写，避免触发邮箱唯一索引冲突
  // 这些字段只能通过专门的「修改邮箱 / 重置密码 / 微信登录回调」接口改动，不能随「编辑资料」整体 UPDATE
  const BLACKLIST_KEYS = new Set([
    'email', 'passwordHash', 'password_hash', 'password',
    'openid', 'unionid', 'createdAt', 'created_at',
    'updatedAt', 'updated_at', 'isAdmin', 'is_admin', 'status', 'userId'
  ])
  // 白名单：username 只在传入字符串时保留（否则沿用数据库原值），未传时不在 userData 里
  const maybeUsername = user.username
  console.log('🔍 [API DEBUG] maybeUsername =', JSON.stringify(maybeUsername), 'typeof =', typeof maybeUsername)
  // 优化数据结构，减少数据长度
  const userData = {
    id: user.id,
    ...(typeof maybeUsername === 'string' && maybeUsername.trim().length > 0 ? { username: maybeUsername.trim() } : {}),
    phone: user.phone,
    title: user.title,
    company: user.company,
    address: user.address,
    wechat: user.wechat,
    bio: user.bio,
    companyDesc: user.companyDesc,
    // 确保头像只保存 URL 字符串，不保存 base64 或对象
    avatar: (() => {
      const avatar = user.avatar
      if (!avatar) return ''
      // 如果是对象，提取 url 字段
      if (typeof avatar === 'object') {
        const url = avatar.url || avatar.src || ''
        if (typeof url === 'string' && url.startsWith('data:')) return ''
        return url || ''
      }
      // 如果是 base64 格式，直接返回空字符串
      if (typeof avatar === 'string' && avatar.startsWith('data:')) {
        console.warn('检测到 base64 格式的头像，将忽略该字段', avatar.substring(0, 50) + '...')
        return ''
      }
      return typeof avatar === 'string' ? avatar : ''
    })(),
    companyName: user.companyName,
    companyBio: user.companyBio,
    // 确保公司 Logo 只保存 URL 字符串，不保存 base64 或对象
    companyLogo: (() => {
      const logo = user.companyLogo
      if (!logo) return ''
      // 如果是对象，提取 url 字段
      if (typeof logo === 'object') {
        const url = logo.url || logo.src || ''
        if (typeof url === 'string' && url.startsWith('data:')) return ''
        return url || ''
      }
      if (typeof logo === 'string' && logo.startsWith('data:')) {
        console.warn('检测到 base64 格式的公司 Logo，将忽略该字段', logo.substring(0, 50) + '...')
        return ''
      }
      return typeof logo === 'string' ? logo : ''
    })(),
    images: (function() {
      if (user.images) {
        if (Array.isArray(user.images)) {
          // 确保图片数组中的每个对象只包含 URL，不包含 base64
          const cleanedImages = user.images.map(image => {
            if (typeof image === 'object' && image.url) {
              // 如果是对象且有 url 属性
              return { ...image, url: image.url.startsWith('data:') ? '' : image.url }
            } else if (typeof image === 'string') {
              // 如果本身就是字符串
              return image.startsWith('data:') ? '' : image
            }
            return image
          }).filter(image => {
            if (typeof image === 'object') {
              return image.url !== ''
            }
            return image !== ''
          })
          return JSON.stringify(cleanedImages.slice(0, 20))
        } else if (typeof user.images === 'string') {
          try {
            const parsed = JSON.parse(user.images)
            // 同样清理解析后的图片数组
            const cleanedImages = (Array.isArray(parsed) ? parsed : []).map(image => {
              if (typeof image === 'object' && image.url) {
                return { ...image, url: image.url.startsWith('data:') ? '' : image.url }
              } else if (typeof image === 'string') {
                return image.startsWith('data:') ? '' : image
              }
              return image
            }).filter(image => {
              if (typeof image === 'object') {
                return image.url !== ''
              }
              return image !== ''
            })
            return JSON.stringify(cleanedImages.slice(0, 20))
          } catch (e) {
            return JSON.stringify([])
          }
        }
      }
      return JSON.stringify([])
    }()), // 限制图片数量
    videos: JSON.stringify(user.videos ? user.videos.slice(0, 10) : []), // 限制视频数量
    resume: user.resume,
    cases: JSON.stringify(user.cases ? user.cases.slice(0, 10) : []), // 限制案例数量
    products: (function() {
      if (user.products) {
        if (Array.isArray(user.products)) {
          return JSON.stringify(user.products.slice(0, 20))
        } else if (typeof user.products === 'string') {
          try {
            const parsed = JSON.parse(user.products)
            return JSON.stringify(Array.isArray(parsed) ? parsed.slice(0, 20) : [])
          } catch (e) {
            return JSON.stringify([])
          }
        }
      }
      return JSON.stringify([])
    }()), // 限制产品数量
    hotProducts: (function() {
      if (user.hotProducts) {
        if (Array.isArray(user.hotProducts)) {
          return JSON.stringify(user.hotProducts.slice(0, 10))
        } else if (typeof user.hotProducts === 'string') {
          try {
            const parsed = JSON.parse(user.hotProducts)
            return JSON.stringify(Array.isArray(parsed) ? parsed.slice(0, 10) : [])
          } catch (e) {
            return JSON.stringify([])
          }
        }
      }
      return JSON.stringify([])
    }()), // 限制热销产品数量
    photos: (function() {
      if (user.photos) {
        if (Array.isArray(user.photos)) {
          // 确保照片数组中的每个对象只包含 URL，不包含 base64
          const cleanedPhotos = user.photos.map(photo => {
            if (typeof photo === 'object' && photo.url) {
              // 如果是对象且有 url 属性
              return { ...photo, url: photo.url.startsWith('data:') ? '' : photo.url }
            } else if (typeof photo === 'string') {
              // 如果本身就是字符串
              return photo.startsWith('data:') ? '' : photo
            }
            return photo
          }).filter(photo => {
            if (typeof photo === 'object') {
              return photo.url !== ''
            }
            return photo !== ''
          })
          return JSON.stringify(cleanedPhotos.slice(0, 20))
        } else if (typeof user.photos === 'string') {
          try {
            const parsed = JSON.parse(user.photos)
            // 同样清理解析后的照片数组
            const cleanedPhotos = (Array.isArray(parsed) ? parsed : []).map(photo => {
              if (typeof photo === 'object' && photo.url) {
                return { ...photo, url: photo.url.startsWith('data:') ? '' : photo.url }
              } else if (typeof photo === 'string') {
                return photo.startsWith('data:') ? '' : photo
              }
              return photo
            }).filter(photo => {
              if (typeof photo === 'object') {
                return photo.url !== ''
              }
              return photo !== ''
            })
            return JSON.stringify(cleanedPhotos.slice(0, 20))
          } catch (e) {
            return JSON.stringify([])
          }
        }
      }
      return JSON.stringify([])
    }()), // 限制图片数量
    // 企业列表（编辑企业信息页保存的多企业 {name, bio, logo} 数组）
    // 注意：如果 companies 是空数组，返回 undefined，不发送到后端，避免清空已有数据
    companies: (function() {
      if (user.companies) {
        if (Array.isArray(user.companies)) {
          // 如果是空数组，返回 undefined，不发送到后端
          if (user.companies.length === 0) return undefined
          // 保留所有企业项（包括空白项），让用户可以编辑
          const cleaned = user.companies
            .map(c => ({
              name: typeof c?.name === 'string' ? c.name.trim() : '',
              bio: typeof c?.bio === 'string' ? c.bio.trim() : '',
              logo: typeof c?.logo === 'string' ? c.logo.trim() : ''
            }))
          return JSON.stringify(cleaned.slice(0, 10))
        } else if (typeof user.companies === 'string') {
          try {
            const parsed = JSON.parse(user.companies)
            if (Array.isArray(parsed)) {
              // 如果解析后是空数组，返回 undefined
              if (parsed.length === 0) return undefined
              const cleaned = parsed
                .map(c => ({
                  name: typeof c?.name === 'string' ? c.name.trim() : '',
                  bio: typeof c?.bio === 'string' ? c.bio.trim() : '',
                  logo: typeof c?.logo === 'string' ? c.logo.trim() : ''
                }))
              return JSON.stringify(cleaned.slice(0, 10))
            }
          } catch (e) {
            return undefined
          }
        }
      }
      // 如果没有 companies 数据，返回 undefined，不发送到后端
      return undefined
    }()),
    showSections: (() => {
      // 如果 showSections 为 null、undefined 或空字符串，返回 undefined，不发送到后端
      if (user.showSections === null || user.showSections === undefined || user.showSections === '') {
        return undefined
      }
      if (typeof user.showSections === 'string') return user.showSections
      if (user.showSections && typeof user.showSections === 'object') return JSON.stringify(user.showSections)
      return undefined
    })(),
    moduleOrder: (() => {
      if (typeof user.moduleOrder === 'string') return user.moduleOrder
      if (Array.isArray(user.moduleOrder)) return JSON.stringify(user.moduleOrder)
      return JSON.stringify(['company', 'video', 'resume', 'cases', 'products', 'photos'])
    })(),
    memberLevel: user.memberLevel || 1
  }
  // ✅ 最终兜底：任何黑名单字段（即使代码后续添加时写进 userData）一律删除后再发请求
  BLACKLIST_KEYS.forEach(k => { delete userData[k] })
  // 删除值为 undefined 的字段，避免发送空数据到后端
  Object.keys(userData).forEach(k => {
    if (userData[k] === undefined) delete userData[k]
  })
  console.log('updateUser: 最终提交的 userData.companies =', userData.companies)
  return request({
    url: '/api/user/update',
    method: 'PUT',
    data: userData
  })
}

// 微信登录二维码 → third-service
export const getWechatLoginQRCode = () => {
  return request({
    url: '/api/third/wechat/login',
    method: 'GET'
  })
}

// 获取微信授权URL → third-service (H5授权)
export const getWechatAuthUrl = () => {
  return request({
    url: '/api/third/wechat/auth',
    method: 'POST'
  })
}



// 通过Token获取用户信息 → 数字名片后端
export const getUserInfoByToken = () => {
  // 导入getUserId函数获取当前用户ID
  const { getUserId } = require('@/utils/auth')
  const userId = getUserId()
  if (userId) {
    return request({
      url: `/api/user/id/${userId}`,
      method: 'GET'
    })
  }
  return Promise.reject(new Error('用户未登录'))
}

// 获取用户统计 → 数字名片后端
export const getUserStats = (userId) => {
  return request({
    url: `/api/user/stats/${userId}`,
    method: 'GET'
  })
}

// 获取所有用户 → 数字名片后端
export const getAllUsers = () => {
  return request({
    url: '/api/user/list',
    method: 'GET'
  })
}

// 设置管理员 → 数字名片后端
export const setAdmin = (phone) => {
  return request({
    url: `/api/user/set-admin/${phone}`,
    method: 'POST'
  })
}

// 同步用户 → 数字名片后端
export const syncUser = (syncData) => {
  return request({
    url: '/api/user/sync',
    method: 'POST',
    data: syncData
  })
}

// 获取商城用户信息 → 数字名片后端
export const getMallUserInfo = (mallToken) => {
  return request({
    url: '/api/user/mall/info',
    method: 'GET',
    params: {
      mallToken: mallToken
    }
  })
}

// 获取商城商品列表 → 数字名片后端
export const getMallProducts = (page = 1, limit = 10) => {
  return request({
    url: '/api/user/mall/products',
    method: 'GET',
    params: {
      page: page,
      limit: limit
    }
  })
}

// 获取商城商品分类 → 数字名片后端
export const getMallCategories = () => {
  return request({
    url: '/api/user/mall/categories',
    method: 'GET'
  })
}

// 获取商城我的订单 → 数字名片后端
export const getMallOrders = (mallToken, page = 1, limit = 10) => {
  return request({
    url: '/api/user/mall/orders',
    method: 'GET',
    params: {
      mallToken: mallToken,
      page: page,
      limit: limit
    }
  })
}